import { Controller } from "@hotwired/stimulus"

// Makes a whole element (typically a table row or a card) behave like a link.
//
//   <tr data-controller="row-link" data-row-link-url-value="/customers/shootings/1" data-action="click->row-link#navigate">
//
// Real links, buttons and form fields inside keep their own behaviour, and
// cmd/ctrl/middle click opens the target in a new tab like a normal link.
export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (!this.urlValue) return
    if (event.target.closest("a, button, input, select, textarea, label")) return
    // Don't hijack the click when the user was selecting text in the row.
    if (window.getSelection && window.getSelection().toString().length > 0) return

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(this.urlValue, "_blank")
    } else {
      window.location.href = this.urlValue
    }
  }
}
